<template>
  <div>
    <v-card width="400" class="mx-auto mt-5" v-if="!jwt">
      <v-card-title>
        <h1 class="display-1">Inicio de sesion</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            label="Nombre de Usuario"
            prepend-icon="mdi-account-circle"
            :rules="[rules.required]"
            v-model="username"
          ></v-text-field>
          <v-text-field
            label="Password"
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :rules="[rules.required]"
            v-model="password"
          ></v-text-field>
        </v-form>
        <span class="red--text" v-if="$store.getters.invalidPassword">Usuario/contraseña invalido</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="info" @click="login">Iniciar sesion</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      }
    };
  },
  methods: {
    login() {
      console.log("login...");

      if (this.$refs.form.validate()) {
        const authData = { username: this.username.toLowerCase(), password: this.password };
        this.$store.dispatch("login", authData);
      }
    }
  },
  computed: {
    email() {
      return this.$store.getters.user ? this.$store.getters.user.email : "";
    },
    stateUsername() {
      return this.$store.getters.user ? this.$store.getters.user.username : "";
    },
    jwt() {
      return this.$store.getters.user ? this.$store.getters.user.jwt : "";
    }
  }
};
</script>